import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderRowRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderrow");
